import React, {useContext, useEffect, useRef, useState} from 'react';
import CommandsContext from '../../context/commandsContext';
import {useMenu} from '../../hooks/useMenu';
import styles from './arrow-button.module.css';

function ArrowButton({onHome, onHomeRight, onExit}) {
  const {commands} = useContext(CommandsContext);
  const {
    onUp,
    onDown,
    onRight,
    onLeft,
    onUpOverride,
    onDownOverride,
    onRightOverride,
    onLeftOverride,
    onLeftHold,
    onRightHold,
  } = commands;

  const [leftMouseDown, setLeftMouseDown] = useState(false);
  const [rightMouseDown, setRightMouseDown] = useState(false);
  const timeoutRef = useRef();

  useEffect(() => {
    if (!onLeftHold) return;
    if (leftMouseDown) {
      timeoutRef.current = setTimeout(() => {
        onLeftHold(leftMouseDown);
      }, 3000);
    } else {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [leftMouseDown]);

  useEffect(() => {
    if (!onRightHold) return;
    if (rightMouseDown) {
      timeoutRef.current = setTimeout(() => {
        onRightHold(rightMouseDown);
      }, 3000);
    } else {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [rightMouseDown]);

  return (
    <>
      <div
        className={styles.leftButton}
        onClick={onLeftOverride || onLeft}
        onMouseDown={() => setLeftMouseDown(true)}
        onMouseUp={() => setLeftMouseDown(false)}></div>

      <div className={styles.upButton} onClick={onUpOverride || onUp}></div>
      <div className={styles.downButton} onClick={onDownOverride || onDown}></div>

      <div
        className={styles.rightButton}
        onClick={onRightOverride || onRight}
        onMouseDown={() => setRightMouseDown(true)}
        onMouseUp={() => setRightMouseDown(false)}></div>
    </>
  );
}

export default ArrowButton;
